import { Box, Text, ThemeContext } from '@vouched.id/vault';
import React, { Fragment, useContext } from 'react';
import { Tooltip } from './Tooltip';
export const DropdownItemsSection = ({ dropdownItems }) => {
    const { tokens } = useContext(ThemeContext).theme;
    return (React.createElement(Box, { display: "grid", flex: "1", marginY: "spacing.xlarge", style: {
            gridTemplateColumns: 'auto auto 1fr',
            gap: '20px',
            alignItems: 'center'
        } }, dropdownItems.map((item) => (React.createElement(Fragment, { key: item.text },
        item.statusIcon,
        React.createElement(Text, { style: {
                ...(!item.available && { color: tokens.colors.textInverseMuted })
            } }, item.text),
        item.tooltip ? React.createElement(Tooltip, null, item.tooltip) : React.createElement("div", null),
        item.penalties && item.penalties.length > 0 && (React.createElement("ul", { style: { gridColumn: 'span 3', margin: 0 } }, item.penalties.map((penalty) => (React.createElement("li", { key: penalty.name, style: { marginBottom: '5px' } },
            React.createElement(Text, { style: {
                    color: tokens.colors.textPrimary,
                    fontSize: tokens.text.size.default,
                    fontWeight: tokens.text.weight.bold,
                    display: 'inline-block'
                } },
                penalty.name,
                ":"),
            ' ',
            React.createElement(Text, { style: {
                    color: tokens.colors.textPrimary,
                    fontSize: tokens.text.size.default,
                    display: 'inline-block'
                } }, penalty.description)))))),
        item.customComponent)))));
};
